import { Badge, type BadgeProps } from "@/components/ui/Badge"
import { Link } from "@/components/ui/Link"
import { cn } from "@/lib/shadcn-utils"

interface PlanBadgeProps extends BadgeProps {
  isPro: boolean
}

export function PlanBadge({ isPro, className, ...props }: PlanBadgeProps) {
  return (
    <Link href="/order" external>
      <Badge
        className={cn("tw-w-16 tw-justify-center", className)}
        variant={isPro ? "default" : "secondary"}
        {...props}
      >
        {isPro ? "Pro" : "Basic"}
      </Badge>
    </Link>
  )
}
